module.exports = __webpack_public_path__ + "static/media/lips.cfbd4dfc.svg";